import { UseInfiniteQueryResult } from "@tanstack/react-query";
import { CSSProperties, ReactElement, ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { IntersectingInfiniteLoadingButton } from "./IntersectingInfiniteLoadingButton";

export const InfiniteList = ({
  query,
  children,
  className,
  style,
}: {
  query: UseInfiniteQueryResult;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}): ReactElement => {
  return (
    <div className={twMerge("overflow-auto", className)} style={style}>
      {children}
      <IntersectingInfiniteLoadingButton query={query} />
    </div>
  );
};
